"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const useWarning_1 = require("../../hooks/useWarning");
const BadgeColor = {
    critical: "badge-surface-color-critical",
    warning: "badge-surface-color-warning",
    success: "badge-surface-color-success",
    info: "badge-surface-color-info",
    neutral: "badge-surface-color-neutral"
};
const Badge = (props) => {
    const { numberLabel, type = "neutral" } = props;
    const { warn } = (0, useWarning_1.useWarning)();
    if (numberLabel !== undefined && numberLabel < 0) {
        warn("numberLabel is restricted to positive numeric values");
    }
    const label = react_1.default.useMemo(() => {
        if (numberLabel !== undefined && numberLabel >= 0) {
            if (numberLabel > 999) {
                warn("numberLabel values that exceed 3 digits will be truncated with a + sign");
                return "999+";
            }
            return numberLabel.toString();
        }
        return undefined;
    }, [numberLabel, warn]);
    const containerStyles = react_1.default.useMemo(() => {
        return {
            display: label ? "inline-flex" : "flex",
            flexShrink: 0,
            alignItems: "center",
            paddingTop: "spacing-1",
            paddingBottom: "spacing-1",
            paddingLeft: "spacing-2",
            paddingRight: "spacing-2",
            borderRadius: "radius-2",
            height: label ? "spacing-5" : "spacing-3",
            width: label ? "max-content" : "spacing-3",
            background: BadgeColor[type]
        };
    }, [label, type]);
    return (react_1.default.createElement(foundations_1.Box, { sx: Object.assign({}, containerStyles) }, label && (react_1.default.createElement(TextV2_1.TextV2, { size: "font-size-1", weight: "medium", letterSpacing: "kerning-2", sx: { color: "white" } }, label))));
};
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map